import React, { SyntheticEvent } from 'react';
import { Button, Header, Icon, Modal, ModalActions, ModalContent, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react';
import { formatDateTime } from '../../../utils/datetimeUtils';
import OrderStatusHistory from '../../../types/entities/OrderStatusHistory';
import { getOrderStatusName } from '../../../utils/helpers';

interface Props {
    statusHistory: OrderStatusHistory[] | undefined;
    openModal: boolean;
    setOpenModal: (open: boolean) => void;
}

const TracingOrderListModal = ({ statusHistory, openModal, setOpenModal }: Props) => {

    const handleCancelModal = (event: SyntheticEvent) => {
        event.preventDefault();
        setOpenModal(false);
    };

    return (
        <>
            <Modal
                closeOnDimmerClick
                closeIcon={true}
                onClose={(event) => handleCancelModal(event)}
                open={openModal} >
                <Header icon="truck" content="Seguimiento del pedido" />
                <ModalContent>
                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>Movimiento</TableHeaderCell>
                                <TableHeaderCell>Fecha</TableHeaderCell>
                            </TableRow>
                        </TableHeader>

                        <TableBody>
                            {statusHistory?.map((statusHistory) => (
                                <TableRow key={statusHistory.id}>
                                    <TableCell>
                                        {getOrderStatusName(statusHistory.status)}
                                    </TableCell>
                                    <TableCell>{formatDateTime(statusHistory.startDate)}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </ModalContent>
                <ModalActions>
                    <Button onClick={(event) => handleCancelModal(event)} >
                        <Icon name="cancel" /> Cancelar
                    </Button>
                </ModalActions>
            </Modal>
        </>
    );
};

export default TracingOrderListModal;
